document.addEventListener('DOMContentLoaded', () => {
  let rebuyEventListenerAdded = false;

  document.querySelectorAll('[aria-controls="cart-drawer"]').forEach((el) => {
    el.addEventListener('click', (evt) => {
      if (window.Rebuy?.SmartCart?.status === 'ready' || rebuyEventListenerAdded) {
        return;
      }

      evt.preventDefault();

      // Set the flag to avoid adding duplicate listeners
      rebuyEventListenerAdded = true;
      document.addEventListener('rebuy:smartcart.ready', () => {
        // Add a slight delay to allow the SmartCart open animation to play.
        // Without this timeout, the cart would show immediately without the slide-in effect.
        setTimeout(function() {
          window.Rebuy.SmartCart.show();
          rebuyEventListenerAdded = false;
        })
      });
    });
  });

  const url = new URL(window.location);
  if (url.searchParams.has('viewcart') && url.searchParams.has('bundle')) {
    document.addEventListener('rebuy:smartcart.show', () => {
      url.searchParams.delete('bundle');
      window.history.replaceState({}, '', url);

      setTimeout(() => {
        if (window.Rebuy && window.Rebuy.Cart) {
          window.Rebuy.Cart.init();
        }
      }, 1000);
    }, { once: true });
  }
});

document.addEventListener('rebuy:smartcart.line-item-removed', (event) => {
  const item = event.detail.item;

  if (item.properties._bundleUid && !window.isCartUpdating) {
    window.isCartUpdating = true;
    const smartcart = event.detail.smartcart;
    const items = smartcart?.cart?.items || [];

    const itemsToRemove = items.filter((currentItem) => {
      return item.properties._bundleUid === currentItem.properties._bundleUid;
    });

    // use Shopify aajax API to update items quantity to 0
    const itemIds = itemsToRemove.map((item) => item.id);
    const updates = itemIds.reduce((acc, itemId) => {
      acc[itemId] = 0;
      return acc;
    }, {});

    const url = Shopify.routes.root + 'cart/update.js';
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    };

    setTimeout(() => {
      fetch(url, options)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          // Handle the response data if needed
          console.log('Items updated successfully:', data);
        })
        .catch((error) => {
          console.error('Error updating items:', error);
        })
        .finally(() => {
          window.isCartUpdating = false;
        });
    }, 500);
  }
});